import {
    Injectable
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Course, User } from '../../models/lots-models';

@Injectable({
    providedIn: 'root'
})
export class UserInstanceDataService {

    chatInited = false;
    private moyo = {};
    public thiscourse: any;
    public enrolledData: any = [];
    public selectedEnrolledIndex: number = -1;
    private channel = {};

    private user = {};

    private session: any = {};

    private moyoids = [];
    private userStatus = {};
    private userChannelStatus = -1;
    private cc = '';
    private moyoindex = 0;
    private teacher = true;
    private subscribed = false;
    private quizData: any = {}
    private assignmentData: any = {};
    private ratingData: any = {};

    retryQuiz:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
    
    constructor() {
    }


    setRatingData(data) {
        this.ratingData = data;
    }

    getRatingData(): any {
        return this.ratingData;
    }
    getAssignmentData() {
        return this.assignmentData;
    }


    setAssignmentData(data) {
        this.assignmentData = data;
    }

    getUserChannelStatus() {
        return this.userChannelStatus
    }

    setUserChannelStatus(status) {
        this.userChannelStatus = status
    }

    getQuizData() {
        return this.quizData;
    }

    setQuizData(data) {
        this.quizData = data;
    }

    getMoyo(): any {
        return this.moyo
    }

    setMoyo(lesson: {}) {
        this.moyo = lesson
    }

    setUserStatus(status: any) {
        this.userStatus = status
    }

    getUserLessonStatus(lesson) {
        return this.userStatus[lesson]
    }

    setUserLessonStatus(lesson, status) {
        this.userStatus[lesson] = status
    }

    getUserStatus() {
        return this.userStatus
    }

    setChannel(channel) {
        this.channel = channel;
        this.moyoindex = 0;
    }

    getChannel() {
        return this.channel;
    }

    setUser(user) {
        this.user = user;
    }

    getUser() {
        return this.user;
    }

    setMoyoIds(moyos) {
        this.moyoids = moyos;
    }

    getMoyoIds() {
        return this.moyoids;
    }

    getCurrentMoyoId() {
        return this.moyoids[this.moyoindex];
    }

    setChannelparam(name, value) {
        this.channel[name] = value;
    }

    getChannelparam(name) {
        return this.channel[name]
    }

    setUserParam(name, value) {
        this.user[name] = value;
    }

    getUserParam(name) {
        return this.user[name]
    }

    setMoyoIndex(index) {
        this.moyoindex = index
    }

    getMoyoIndex() {
        return this.moyoindex
    }

    nowTeacher() {
        this.teacher = true;
    }

    nowNotTeacher() {
        this.teacher = false;
    }

    isNowTeacher() {
        return this.teacher
    }

    nowSubscribed() {
        this.subscribed = true;
    }

    nowNotSubscribed() {
        this.subscribed = false;
    }

    isSubscribed() {
        return this.subscribed;
    }


    resetChannel() {
        this.channel = {
            id: null
        }
        this.chatInited = false;
        this.moyoindex = 0;
        this.teacher = false;
        this.subscribed = false;
        this.assignmentData = null;
        this.quizData = null;
    }

    resetUser() {
        this.user = {};
        this.quizData = null;
        this.assignmentData = null;
    }

    setcc(cc) {
        this.cc = cc;
    }

    getcc() {
        return this.cc;
    }

    setSession(data) {
        this.session = data
    }

    getSession() {
        return this.session;
    }


    setRetryQuiz(){
        console.log('setRetryQuiz');
        this.retryQuiz.next(true);
    }
    resetRetryQuiz(){
        this.retryQuiz.next(false);

    }
}
